export default {
    header: {
        featureItem: {
            heading: 'Define Audience',
            description: 'Identify the participants of this feedback cycle',
        },
    },
    content: {
        heading: 'Audience Selection Settings',
        description: 'Define the criteria for automatic respondent suggestions',
        entireCompany: {
            label: 'Entire Company',
            description: 'All users in the company',
        },
        filterByAttributes: {
            label: 'Filter by Attributes',
            description: 'Filter users based on attributes',
        },
        selectParticipatingAudience: 'Select Participating Audience',
    },
    displaySelectedEmployees:
        'Display the number of selected active employees for this audience: {{count}}',
    validation: {
        noAudience: 'Please select at least one employee for the audience',
    },
};
